import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildCategorySeo, resolveSiteOrigin } from '@/content/seo';
import { seoArtifactToHead } from '@/config/seo-head';
import type { WritingCategory } from '@/content/registry';
import { WritingCategoryPage } from '@/features/writing/components/writing-category-page';
import { loadWritingCategory } from '@/features/writing/writing-loaders';

export const Route = createFileRoute('/blog/category/$category')({
  loader: async ({ params }) => {
    const result = await loadWritingCategory({ data: params.category });
    if (!result) {
      throw notFound();
    }
    return result;
  },
  head: ({ params }) => {
    const category = params.category as WritingCategory;
    return seoArtifactToHead(buildCategorySeo(category, resolveSiteOrigin()));
  },
  component: WritingCategoryRoute,
});

function WritingCategoryRoute() {
  const { category, posts, activeCategories } = Route.useLoaderData();
  return (
    <WritingCategoryPage
      category={category}
      posts={posts}
      activeCategories={activeCategories}
    />
  );
}
